import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import '@/styles/index.scss' // global css
import '@/styles/theme.scss'
import Payroll from './Payroll'
import router from './router'
import store from './store'
import '@/icons' // icon
import '@/permission' // permission control
// import '@/socket' // websocket config
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/js/all.js'
import '@fortawesome/fontawesome-free/css/all.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import 'element-ui/lib/theme-chalk/display.css'
import '@/styles/element-variables.scss'
import VueMoment from 'vue-moment'
import Print from 'vue-print-nb'
import vueDebounce from 'vue-debounce'
import VueTimeago from 'vue-timeago'
import { firestorePlugin } from 'vuefire'
import VueNativeNotification from 'vue-native-notification'

import Echo from 'laravel-echo'
window.Pusher = require('pusher-js')

if (process.env.NODE_ENV === 'development') {
  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'hris2019_key',
    cluster: 'mt1',
    wsHost: 'localhost',
    wsPort: '6001'
  })
} else if (process.env.NODE_ENV === 'production') {
  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'hris2019_key',
    cluster: 'mt1',
    wssPort: '6001',
    // wsHost: process.env.WS_HOST,
    wsHost: 'api.hris.vsu.edu.ph',
    disableStats: true,
    encrypted: true
  })
} else if (process.env.NODE_ENV === 'staging') {
  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'hris2019_key',
    cluster: 'mt1',
    wsPort: '6001',
    wsHost: '172.16.0.101',
    disableStats: true,
    forceTLS: false
  })
}

Vue.prototype.$echo = window.Echo

// import { Bar } from 'vue-chartjs'

Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true
})
Vue.notification.requestPermission()
  .then(console.log)
Vue.use(firestorePlugin)
// The vue debounce will delay a method when call
Vue.use(vueDebounce, {
  defaultTime: '500ms'
})
Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en'// Default locale
})
Vue.use(Print)

import jQuery from 'jquery'
var $ = jQuery
window.$ = $

Vue.use(ElementUI, { locale })
Vue.use(VueMoment)
Vue.config.productionTip = false

router.beforeResolve((to, from, next) => {
  var allowed_views = store.getters.views
  var views = allowed_views.concat(store.getters.default_views)
  if (to.name) {
    if (to.meta.group !== 'DEFAULT') {
      if (views.indexOf(to.meta.group.toUpperCase()) < 0) {
        router.push('404')
      } else {
        next()
      }
    } else {
      next()
    }
  }
  next()
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(Payroll)
})
